import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1.5" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  "data-example": "",
  class: "m-0 text-[13px] italic text-gray-500"
}

import { useId } from 'vue'


export default {
  __name: 'AgentMessageField',
  props: {
  modelValue: { type: String, default: '' },
  label: { type: String, required: true },
  example: { type: String, default: '' }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {


const emit = __emit

const id = `message-${useId()}`

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: id,
      class: "text-sm font-medium text-gray-700"
    }, _toDisplayString(__props.label), 1),
    _createElementVNode("textarea", {
      id: id,
      value: __props.modelValue,
      rows: "4",
      class: "block w-full rounded-md border border-gray-300 px-2.5 py-2 text-sm leading-5 text-gray-900 shadow-sm",
      onInput: _cache[0] || (_cache[0] = $event => (emit('update:modelValue', $event.target.value)))
    }, null, 40, _hoisted_2),
    (__props.example)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.example), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}